package nl.volleyplanner.web.base.controller

import kotlinx.dom.clear
import kotlinx.html.dom.append
import kotlinx.html.js.h1
import kotlinx.html.js.p
import nl.volleyplanner.web.base.routing.PageMountContext
import nl.volleyplanner.web.base.routing.PageRouteController
import nl.volleyplanner.web.base.routing.RouteChange

class NotFoundPageController : PageRouteController {
    override fun createRuntimeInstance() = NotFoundPageController()

    override suspend fun mount(context: PageMountContext) {
        context.root.clear()
        context.root.append {
            h1 { +"Niet gevonden" }
            p {
                +"Pagina niet gevonden voor ${context.pageRouteContext.urlState.path}"
            }
        }
    }

    override suspend fun update(change: RouteChange) {

    }

    override suspend fun unmount() {
    }
}